export const css = {
	root: '_1o38BImh',
	title: '_3Gaj-lSY',
	body: '_3jBP0d2G',
	warning: '_31w_4iV9',
	' _key': 'certwise-theme/certwise/learning-activity/activity'
};

export default css;
